"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const calculateCappedModuleDuration_1 = __importDefault(require("./calculateCappedModuleDuration"));
function calculateCappedSessionDuration(modules) {
    const durations = modules.map(m => (0, calculateCappedModuleDuration_1.default)(m.timeStarted, m.timeFinished));
    return durations.reduce((previousValue, currentValue) => previousValue + currentValue, 0);
}
exports.default = calculateCappedSessionDuration;
